import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/subscription/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const subscription = {
  get: apiPathFunc(pathBase),
} as const;
